import React from 'react';
import { Link } from 'react-router-dom';
import { Link2 } from 'lucide-react';
import { Card } from '../../ui/Card';
import { DetailField } from './DetailField';
import { formatCourseDate, getTrainedCourses, productLabel, venueLabel } from '../../../utils/trainingCourses';
import { TrainingCourse } from '../../../types/trainingCourse';
interface CourseInfoCardProps {
  course: TrainingCourse;
  courses: TrainingCourse[];
}
export function CourseInfoCard({
  course,
  courses
}: CourseInfoCardProps) {
  const lead = course.leadCourseId ? courses.find(c => c.id === course.leadCourseId) : undefined;
  const trained = getTrainedCourses(courses, course.id);
  const isOnDemand = course.status === 'ondemand';
  return <Card title="Dati corso" noHoverShadow data-id="element-1182" data-mp="hnvf83dyllwa">
      <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5" data-id="element-1183" data-mp="1e69i4x0i86pr">
        <DetailField label="Tipologia di corso + codice prodotto" full data-id="element-1184" data-mp="1e7ko93hf9qk1">
          {productLabel(course.productCode)}
        </DetailField>
        <DetailField label="Codice specifico del corso" data-id="element-1185" data-mp="38625y02ldo7k">
          <span className="font-mono" data-id="element-1186" data-mp="386kbjnb59es5">{course.courseCode}</span>
        </DetailField>
        <DetailField label="Acquisto prodotto esterno" data-id="element-1187" data-mp="3d4c6yrazzj13">
          {course.externalProduct ? 'Sì' : 'No'}
        </DetailField>
        {course.status !== 'ondemand' && <>
            <DetailField label="Data inizio corso" data-id="element-1188" data-mp="33dr95635eij8">
              {formatCourseDate(course.startDate)}
            </DetailField>
            <DetailField label="Data fine corso" data-id="element-1189" data-mp="2phdr9vupcf48">
              {formatCourseDate(course.endDate)}
            </DetailField>
          </>}
        <DetailField label="Caratteristica del corso" data-id="element-1190" data-mp="2fhmzw31fug8d">
          {course.characteristic}
        </DetailField>
        {course.characteristic === 'Trainato' && <DetailField label="Corso trainante" data-id="element-1191" data-mp="2ki14tc7qta26">
            {lead ? <Link to={`/training/corsi/${lead.id}`} className="text-seform-orange hover:underline" data-id="element-1192" data-mp="dq9w5hb7iedw">
                {lead.courseCode} — {lead.name}
              </Link> : 'Nessun corso collegato'}
          </DetailField>}
        {!isOnDemand && <>
            <DetailField label="Commessa" data-id="element-1193" data-mp="78q6ccigutti">
              {course.commission === 'SEFORM' ? 'Commessa SEFORM' : `Commessa cliente — ${course.clientName || '-'}`}
            </DetailField>
            <DetailField label="Sede" data-id="element-1194" data-mp="zwudz3kllgyu">{venueLabel(course.venue)}</DetailField>
            {course.venue === 'cliente' && <DetailField label="Sede del cliente" full data-id="element-1195" data-mp="uzug3fxwjkit">
                {course.clientSite}
              </DetailField>}
          </>}
      </dl>

      {course.characteristic === 'Trainante' && <div className="mt-6 pt-5 border-t border-slate-100" data-id="element-1196" data-mp="m4xxxxw7exit">
          <p className="text-sm font-medium text-seform-navy flex items-center gap-2 mb-2" data-id="element-1197" data-mp="1iq82aptt2p5h">
            <Link2 className="h-4 w-4" data-id="element-1198" data-mp="1dx57kedal9np" /> Corsi trainati
          </p>
          {trained.length > 0 ? <ul className="space-y-1.5" data-id="element-1199" data-mp="2wm9cmsl464m8">
              {trained.map(c => <li key={c.id} className="text-sm" data-id="element-1200" data-mp="31kt1b0r3duia">
                  <Link to={`/training/corsi/${c.id}`} className="text-slate-700 hover:text-seform-orange" data-id="element-1201" data-mp="31lm9m65p8s2j">
                    <span className="font-mono text-xs text-slate-500 mr-2" data-id="element-1202" data-mp="3am0y1edymna9">
                      {c.courseCode}
                    </span>
                    {c.name}
                  </Link>
                </li>)}
            </ul> : <p className="text-sm text-slate-500" data-id="element-1203" data-mp="3p8u7i30ssyuj">
              Nessun corso trainato collegato.
            </p>}
        </div>}
    </Card>;
}